// Helpers for exporting reports to Excel using SheetJS
import * as XLSX from "xlsx";

export function exportToExcel(filename, sheets) {
  // sheets: [{ name, columns: [{key, header}], rows: [...] }]
  const wb = XLSX.utils.book_new();
  sheets.forEach((sheet) => {
    const data = [sheet.columns.map(c => c.header)];
    sheet.rows.forEach((r) => {
      data.push(sheet.columns.map(c => r[c.key] ?? ""));
    });
    const ws = XLSX.utils.aoa_to_sheet(data);
    if (!ws["!views"]) ws["!views"] = [{}];
    ws["!views"][0].rightToLeft = true;
    ws["!cols"] = sheet.columns.map(c => ({ wch: Math.max(String(c.header).length + 4, 14) }));
    XLSX.utils.book_append_sheet(wb, ws, sheet.name.slice(0, 31));
  });
  XLSX.writeFile(wb, filename);
}
